import { DB_DATE_TIME_FORMAT } from 'core/constants';
import { formatDateForServer } from 'core/utils';
import { getNoDeliveryDateSubmissionDay, isNoDeliveryDate } from 'quotes/utils';

import { ISubmitOrderForm, ISubmitOrderFormOptions } from './types';

export const mapSubmitOrderForm = (
  data: ISubmitOrderForm,
  quoteId: number,
  options: ISubmitOrderFormOptions = {
    isCompanyAdmin: false,
    isAlternateVersionEnabled: false,
  }
) => {
  const formData = {
    salesLocationId: data?.location.vendorId,
    quote: { id: quoteId },
    ...(options.isAlternateVersionEnabled
      ? {
          orderType: data.orderType,
          shipSelection: data.shipSelection,
          // NDD (empty = NDD on submit): the user's local day; the BE accepts it within ±1 day of
          // its own day, else falls back to the server's day.
          earliestAcceptableDate: isNoDeliveryDate(data.shipSelection)
            ? getNoDeliveryDateSubmissionDay().format(DB_DATE_TIME_FORMAT)
            : formatDateForServer(data?.earliestAcceptableDate?.toString(), DB_DATE_TIME_FORMAT),
          requiredOnSiteDate: formatDateForServer(
            data?.requiredOnSiteDate?.toString(),
            DB_DATE_TIME_FORMAT
          ),
          shippingMethodId: data?.shippingMethod?.id,
          freightTermId: data?.freightTerm?.id,
        }
      : {}),
  };

  if (options.isAlternateVersionEnabled && !options.isCompanyAdmin) {
    return formData;
  }

  return {
    ...formData,
    externalUserId: data?.externalUserId,
  };
};
